import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['sentinel']
    static values = {
        loading: { type: Boolean, default: false },
    }

    connect() {
        this.createObserver()
        this.observeSentinel()

        // Bind once and reuse
        this.boundBeforeStreamRender = this.handleBeforeStreamRender.bind(this)
        this.boundFrameLoad = this.handleFrameLoad.bind(this)
        this.boundFetchError = this.handleFetchError.bind(this)

        document.addEventListener('turbo:before-stream-render', this.boundBeforeStreamRender)
        document.addEventListener('turbo:frame-load', this.boundFrameLoad)
        document.addEventListener('turbo:fetch-request-error', this.boundFetchError)
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect()
        }

        document.removeEventListener('turbo:before-stream-render', this.boundBeforeStreamRender)
        document.removeEventListener('turbo:frame-load', this.boundFrameLoad)
        document.removeEventListener('turbo:fetch-request-error', this.boundFetchError)
    }

    sentinelTargetConnected() {
        // When a new sentinel is added, observe it
        this.observeSentinel()
    }

    sentinelTargetDisconnected() {
        // When sentinel is removed, stop loading
        this.loadingValue = false
    }

    createObserver() {
        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
            root: null, // viewport
            rootMargin: '250px', // Trigger this amount of px before reaching the element
            threshold: 0.1,
        })
    }

    observeSentinel() {
        if (this.hasSentinelTarget && this.observer) {
            this.observer.observe(this.sentinelTarget)
        }
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !this.loadingValue) {
                this.loadMore()
            }
        })
    }

    handleBeforeStreamRender() {
        // Stop loading state when stream starts rendering
        this.loadingValue = false
    }

    handleFrameLoad() {
        // Reset loading state when frame finishes loading
        this.loadingValue = false
    }

    loadMore() {
        // Find the load more link - if it doesn't exist, we're done
        const link = this.sentinelTarget?.querySelector('a[data-turbo-stream]')

        if (!link) {
            // No link means no more pages - this is handled by the server response
            this.loadingValue = false
            return
        }

        if (link && !this.loadingValue) {
            this.loadingValue = true
            link.click()
        }
    }

    handleFetchError(event) {
        // Only handle errors related to our infinite scroll requests
        const container = document.getElementById('load-more-container')

        if (this.loadingValue && container) {
            console.error('Error loading more chats:', event)
            this.loadingValue = false

            // Show error message with retry option
            container.innerHTML = `
                <div class="text-center">
                    <small class="text-danger d-block mb-2">Fehler beim Laden</small>
                    <button class="btn btn-sm btn-outline-secondary" onclick="location.reload()">
                        Erneut versuchen
                    </button>
                </div>
            `
        }
    }
}
